import { render, staticRenderFns } from "./calendar-display.vue?vue&type=template&id=24a10d40&"
import script from "./calendar-display.vue?vue&type=script&lang=js&"
export * from "./calendar-display.vue?vue&type=script&lang=js&"
import style0 from "./calendar-display.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports